import { Grid } from "@mui/material";
import DetailLink from "@src/components/DetailLink";
import ReadOnlyDetailField from "@src/components/fields/ReadOnlyDetail";
import ReadOnlyDetails from "@src/components/ReadOnlyDetails";
import { type GQLPurchaseAdminQuery } from "@src/graphql.generated";
import { type FC, type FunctionComponent, type PropsWithChildren } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { DetailLinkIcon } from "./UserInformation.sc";

interface ShowUserLinkProps {
    id: string;
}
const ShowUserLink: FunctionComponent<PropsWithChildren<ShowUserLinkProps>> = ({ id }) => (
    <DetailLink to={`/users/${id}/edit`}>
        <DetailLinkIcon />
        <FormattedMessage id="reviermanager.purchases.detail.user.link" defaultMessage="Benutzer zeigen" />
    </DetailLink>
);

const UserInformation: FC<PropsWithChildren<GQLPurchaseAdminQuery>> = ({ licenceAdmin }) => {
    const intl = useIntl();

    if (!licenceAdmin.camera?.user) {
        return null;
    }
    const { firstname, lastname, email, id } = licenceAdmin.camera.user;

    return (
        <Grid size={12}>
            <ReadOnlyDetails
                title={intl.formatMessage({ id: "reviermanager.purchases.detail.user.title", defaultMessage: "Kunde" })}
                link={<ShowUserLink id={id} />}
            >
                <ReadOnlyDetailField
                    value={firstname}
                    label={intl.formatMessage({ id: "reviermanager.purchases.detail.user.firstname", defaultMessage: "Vorname" })}
                />
                <ReadOnlyDetailField
                    value={lastname}
                    label={intl.formatMessage({ id: "reviermanager.purchases.detail.user.lastname", defaultMessage: "Nachname" })}
                />
                <ReadOnlyDetailField
                    value={email}
                    label={intl.formatMessage({ id: "reviermanager.purchases.detail.user.email", defaultMessage: "E-Mail" })}
                />
                <ReadOnlyDetailField
                    value={id}
                    label={intl.formatMessage({ id: "reviermanager.purchases.detail.user.id", defaultMessage: "Benutzer-ID" })}
                />
            </ReadOnlyDetails>
        </Grid>
    );
};

export default UserInformation;
